module.exports = __webpack_public_path__ + "img/mantención.1454c0dc.png";